import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PageTitle from "../../components/shared/PageTitle";
import Widget from "../../components/shared/Widget";
import AccountWidget from "../../components/shared/AccountWidget";
import { Link } from "react-router-dom";
import CategoriesWidget from "../../components/shared/CategoriesWidget";
import ProductItem from "../../components/ProductItem";
import Loading from "../../components/shared/Loading";
import { getOrder } from "../../store/actions/order";
import styles from "../../thema/style";
import { PUBLIC_URL } from "../../config";
import moment from "moment";
import "moment/locale/tr";
import CheckoutCart from "../../components/CheckoutCart";
import OrderDetailProducts from "../../components/OrderDetailProducts";
import OrderDetailInfo from "../../components/OrderDetailInfo";
import OrderDetailAdress from "../../components/OrderDetailAdress";
import OrderDetailInfoDetail from "../../components/OrderDetailInfoDetail";
import OrderDetailHistory from "../../components/OrderDetailHistory";
moment.locale("tr");

class OrderDetail extends Component {
  componentDidMount() {
    this.props.getOrder(this.props.location.state.id);
  }

  // static getDerivedStateFromProps(props, state) {
  //   props.getOrder(props.location.state.id);
  //   return null;
  // }

  render() {
    if (this.props.customer.fetching) {
      return <Loading text={"Sayfa Yükleniyor..."} />;
    } else {
      if (!this.props.customer.customer) {
        return (
          <Redirect
            to={{
              pathname: "/giris-yap",
              // state: { referrer: currentLocation }
            }}
          />
        );
      }
      if (!this.props.order.order) {
        return <Loading text={"Sayfa Yükleniyor..."} />;
      }

      const address = this.props.order.order.customer.addresses.find(
        (address) => {
          if (
            this.props.order.order.address.toString() === address.id.toString()
          ) {
            return true;
          } else {
            return address.active === true;
          }
        }
      );

      return (
        <React.Fragment>
          <PageTitle title={"Sipariş Detayları"} />
          <div className="row">
            <div className={"container"}>
              <div className="row">
                <div className={"col-md-9"} style={{ marginTop: 15 }}>
                  <h2>Sipariş Detayları</h2>
                  {this.props.order.fetching ? (
                    <Loading text={"Sipariş Detayları Yükleniyor..."} />
                  ) : (
                    <React.Fragment>
                      <OrderDetailInfo customer={true} {...this.props} />
                      <OrderDetailAdress customer={true} address={address} />

                      <OrderDetailProducts
                        header={true}
                        products={this.props.order.order.products.map(
                          ({ product, quantity, price }) => ({
                            ...product,
                            quantity,
                            salePrice: price,
                          })
                        )}
                        {...this.props}
                      />
                      <OrderDetailInfoDetail customer={true} {...this.props} />
                      <h4 style={{ marginTop: 30 }}>Sipariş Geçmişi</h4>
                      <OrderDetailHistory customer={true} {...this.props} />
                    </React.Fragment>
                  )}
                </div>
                <div className={"col-md-3"}>
                  <AccountWidget />
                  <CategoriesWidget />
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      );
    }
  }
}

const mapStateToProps = ({ customer, order }) => {
  return { customer, order };
};

const mapDispatchToProps = { getOrder };

export default connect(mapStateToProps, mapDispatchToProps)(OrderDetail);



// WEBPACK FOOTER //
// ./src/routers/Account/order_detail.js